import eventBus from '../messaging/event-bus';
import { AccountLogoUploaded } from '../messaging/events';
import repository from './account-repository';
import api from '../api';

// eslint-disable-next-line import/prefer-default-export
export function getType(accountId: string): Promise<number> {
  return repository.find(accountId).then(account => account.type);
}

function dataUrlToBase64(dataUrl: string) {
  return dataUrl.replace(/^data:(.+);base64,/gi, '');
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(dataUrlToBase64(reader.result));
      else reject();
    };
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
}

export function add(account): Promise<Account> {
  const resource = account;
  resource.address.countryId = resource.address.country.id;
  return api
    .post(`accounts/${account.parentId}/accounts`, resource)
    .then(response => response.data);
}

export function uploadLogo(accountId: string, logo: File): Promise<string> {
  return new Promise((resolve, reject) => {
    fileToBase64(logo).then((fileContent) => {
      const url = `accounts/${accountId}/logo`;
      api.put(url, { fileName: logo.name, fileContent })
        .then((response) => {
          eventBus.$emit(AccountLogoUploaded.eventName, {
            accountId,
            logoUrl: response.data.url,
          });
          resolve(response.data.url);
        })
        .catch(reject);
    });
  });
}
